<!-- app-routing.module.ts Components should have Breadcrumbs at the top -->
<nav class="breadcrumbs">
  <ul class="pagination">
    <li class="dark"><a routerLink="/">{{ dashboardService.client.name }}</a></li>
    <li class="disabled"><a routerLink="/smm">SMM</a></li>
  </ul>
  <a routerLink="/smm/settings"><i class="large glyphicon glyphicon-cog"></i></a>
  <br />
  <a class="underline reverse" *ngIf="dashboardService.website" target="_blank" href="{{ '//' + dashboardService.website.domain }}">
    {{ dashboardService.website.domain }}
  </a>
</nav>
